import c from 'classnames';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { WithStyles, ITheme } from 'core/style/interfaces';
import { isMobile } from 'core/utils';
import React from 'react';
import ArrowLeftIcon from '../svg/arrow_left.svg';

type ITabProps = {
    tabName: string;
    currentTab: string;
    className?: string;
    label: string;
    onSelect: (tabName: string) => void;
} & WithStyles<typeof styles>;

const Tab: React.StatelessComponent<ITabProps> = ({ classes, tabName, currentTab, label, onSelect, className }) => (
    <div
        className={c(classes.tab, className, { [classes.tabSelected]: currentTab === tabName })}
        onClick={() => onSelect(tabName)}
    >
        {label}
        {isMobile() && <ArrowLeftIcon className={classes.tabIcon} />}
    </div>
);

const styles = (theme: ITheme) =>
    createStyles({
        tab: {
            fontSize: 1.1 + 'rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            borderBottom: `3px solid #DADADA`,
            padding: '3px 25px',
            flexGrow: 1,
            textAlign: 'center',

            '&:hover': {
                borderBottom: `3px solid ${theme.colors.accent}`,
            },

            [theme.breakpoints.down('xs')]: {
                marginBottom: 1 + 'rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '3px 0px',
            },
        },
        tabSelected: {
            borderBottom: `3px solid ${theme.colors.accent}`,
        },
        tabIcon: {
            width: 16,
            height: 16,
            fill: theme.colors.black,
            marginRight: 5,
            transform: 'rotate(-90deg)',
        },
    });

export default injectSheet(styles, 'Tab')(Tab);
